'use strict';Object.defineProperty(exports,"__esModule",{value:true});exports.getVersionString=getVersionString;var VERSION='3.2.2';function getVersionString(){return VERSION;}
//# sourceMappingURL=Version.js.map
